import { ConsumerType } from './types/consumer-type';
import { doesWindowExist } from './utils/global';

export enum EnvironmentVariable {
  VISION_URL = 'VISION_URL',
  CLOUDFRONT_STATIC_ASSET_URL = 'CLOUDFRONT_STATIC_ASSET_URL',
  VUE_APP_VID_CDN_URL = 'VUE_APP_VID_CDN_URL',
  CONSUMER_TYPE = 'CONSUMER_TYPE',
  CVENT_ENVIRONMENT = 'CVENT_ENVIRONMENT'
}

type MandatoryVariableType = { mandatory: true };
type OptionalVariableType = { mandatory: false; fallback: string | undefined };

type EnvVariableConfigType = { [key in EnvironmentVariable]: MandatoryVariableType | OptionalVariableType };

const ENV_VARIABLE_CONFIG: EnvVariableConfigType = {
  [EnvironmentVariable.VISION_URL]: {
    mandatory: true
  },
  [EnvironmentVariable.CLOUDFRONT_STATIC_ASSET_URL]: {
    mandatory: true
  },
  [EnvironmentVariable.VUE_APP_VID_CDN_URL]: {
    mandatory: true
  },
  [EnvironmentVariable.CONSUMER_TYPE]: {
    mandatory: false,
    fallback: ConsumerType.Goldcast
  },
  [EnvironmentVariable.CVENT_ENVIRONMENT]: {
    mandatory: false,
    fallback: undefined
  }
};

const getEnvVariableFromConfig = (name: EnvironmentVariable) => {
  if (doesWindowExist()) {
    // @ts-ignore
    return window?.configs?.[name] || process.env?.[name];
  }
  // @ts-ignore
  return process.env?.[name];
};

export const getEnvValue = (name: EnvironmentVariable): string | undefined => {
  const value = getEnvVariableFromConfig(name);
  const isNodeEnv = !doesWindowExist();
  const isMandatory = ENV_VARIABLE_CONFIG[name].mandatory;

  if (isNodeEnv && isMandatory && !value) {
    throw new Error(`[player-config] Required env var "${name}" is not defined`);
  }

  if (!isMandatory && !value) {
    return ENV_VARIABLE_CONFIG[name].fallback;
  }

  return value;
};

Object.values(EnvironmentVariable).forEach(flag => getEnvValue(flag));
